/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetCompaniesResponse } from '../../models/get-companies-response';

export interface GetUniqueCompanies$Params {
  verificationStatus?: string;
}

export function getUniqueCompanies(http: HttpClient, rootUrl: string, params?: GetUniqueCompanies$Params, context?: HttpContext): Observable<StrictHttpResponse<GetCompaniesResponse>> {
  const rb = new RequestBuilder(rootUrl, getUniqueCompanies.PATH, 'get');
  if (params) {
    rb.query('verificationStatus', params.verificationStatus, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetCompaniesResponse>;
    })
  );
}

getUniqueCompanies.PATH = '/api/v1/companies';
